const updates = {
  tittle: `Usuario administrador y corrección de errores.`,
  date: `02/11/2023`,
  descriptions: [
    `<p style="text-align: justify">Para evitar malas prácticas en la administración de usuarios que pueda ocurrir de manera interna con los distribuidores,
 hemos cambiado el proceso de creación y edición de usuarios administradores. Se ha  deshabilitado la creación y edición de usuarios nivel administrador,
  esto era un proceso auto administrable y completamente gestionado por el distribuidor, que sufre un cambio a partir de la fecha del comunicado.
  <br>
    En caso de requerir un usuario de este tipo favor de comunicarse con el servicio de FYF Soluciones al correo <a href="administracion@fyf.mx">administracion@fyf.mx</a> solicitando la creación o edición del mismo.
      </p>
`,
  ],
  sections: [
    {
      tittle: `Recargar.`,
      children: [
        {
          description: `Se ha corregido un error que no permite cargar de forma correcta los módulos de consultar estatus de AT&T.`
        },
      ]
    },
    {
      tittle: `Registrar Usuarios.`,
      children: [
        {
          description: `Se Deshabilitó la opción de nivel de tipo administrador.`,
          image: `update02112023-RU-1.png`
        },
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,
        }
      ]
    },
    {
      tittle: `Editar Usuarios.`,
      children: [
        {
          description: `Se Deshabilitó la opción de nivel de tipo administrador.`,
          image: `update02112023-RU-1.png`
        },
        {
          description: `Se actualizaron los botones e iconos.`
        },
        {
          description: `Se ha agregado un botón para ocultar los filtros.`
        },
        {
          description: `Se añadieron etiquetas al momento de  pasar el cursor sobre el botón.`,
        }
      ]
    },
  ]

}


module.exports = {
  updates
}